import { render, staticRenderFns } from "./groupFormItem.vue?vue&type=template&id=d1ae4ed4&scoped=true"
import script from "./groupFormItem.vue?vue&type=script&lang=js"
export * from "./groupFormItem.vue?vue&type=script&lang=js"
import style0 from "./groupFormItem.vue?vue&type=style&index=0&id=d1ae4ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ae4ed4",
  null
  
)

export default component.exports